// src/utils/audioManager.js
// VERSÃƒO CORRIGIDA - SEM loop infinito de inicializaÃ§Ã£o

let globalAudioElement = null;
let globalSpotElement = null;
let listeners = new Set();
let isInitialized = false; // âœ… Flag para prevenir re-inicializaÃ§Ã£o
// ðŸ”¶ Hook de alta prioridade executado ANTES de notificar 'ended'
let beforeEndedHook = null;
export const setBeforeMusicEndHook = (fn) => {
  beforeEndedHook = typeof fn === 'function' ? fn : null;
};

// FunÃ§Ã£o principal - expÃµe globalmente via window
export const initGlobalAudio = () => {
  // âœ… Se jÃ¡ foi inicializado, retorna elementos existentes
  if (isInitialized && globalAudioElement && globalSpotElement) {
    return { 
      audioElement: globalAudioElement, 
      spotElement: globalSpotElement 
    };
  }
  
  // âœ… Primeira inicializaÃ§Ã£o do Audio Element
  if (!globalAudioElement) {
    console.log('[AudioManager] ðŸŽµ Criando audioElement...');
    globalAudioElement = new Audio();
    globalAudioElement.preload = 'metadata';
    globalAudioElement.id = 'global-audio';
    
    // IMPORTANTE: Expor globalmente via window
    window.__globalAudioElement = globalAudioElement;
    
    // Adicionar eventos essenciais
    setupAudioEvents(globalAudioElement);
  }
  
  // âœ… Primeira inicializaÃ§Ã£o do Spot Element
  if (!globalSpotElement) {
    console.log('[AudioManager] ðŸ“¢ Criando spotElement...');
    globalSpotElement = new Audio();
    globalSpotElement.preload = 'metadata';
    globalSpotElement.id = 'spot-audio';
    
    // IMPORTANTE: Expor globalmente via window
    window.__globalSpotElement = globalSpotElement;
    
    // Eventos do spot
    globalSpotElement.addEventListener('ended', () => {
      notifyListeners('spotEnded');
    });
  }
  
  // âœ… Marcar como inicializado (sÃ³ loga UMA VEZ)
  if (!isInitialized) {
    isInitialized = true;
    console.log('[AudioManager] âœ… Inicializado com sucesso!');
    console.log('   audioElement:', !!globalAudioElement);
    console.log('   spotElement:', !!globalSpotElement);
    console.log('   expostoGlobalmente:', true);
  }
  
  return { 
    audioElement: globalAudioElement, 
    spotElement: globalSpotElement 
  };
};

// Manter funÃ§Ãµes originais
export const getAudioElement = () => {
  if (!globalAudioElement) {
    initGlobalAudio();
  }
  return globalAudioElement;
};

export const getSpotElement = () => {
  if (!globalSpotElement) {
    initGlobalAudio();
  }
  return globalSpotElement;
};

// Configurar eventos do player principal
function setupAudioEvents(audio) {
  // âš ï¸ REMOVIDO: Auto-avanÃ§o (deixa useAudio.js controlar)
  // Apenas notifica que terminou
  audio.addEventListener('ended', async () => {
    console.log('[AudioManager] ðŸŽµ MÃºsica terminou (evento notificado)');
    // ðŸ”¶ DÃª prioridade ao spot ANTES de qualquer outro listener
    if (beforeEndedHook) {
      try { await beforeEndedHook(); } 
      catch (e) { console.warn('[AudioManager] beforeEndedHook falhou:', e); }
    }
    notifyListeners('ended');
    // useAudio.js ainda serÃ¡ notificado, mas sÃ³ DEPOIS do spot
  });
  
  // Outros eventos Ãºteis
  audio.addEventListener('timeupdate', () => {
    notifyListeners('timeupdate', {
      currentTime: audio.currentTime,
      duration: audio.duration || 0
    });
  });
  
  audio.addEventListener('loadedmetadata', () => {
    notifyListeners('loadedmetadata', {
      duration: audio.duration
    });
  });
  
  audio.addEventListener('play', () => {
    notifyListeners('play');
  });
  
  audio.addEventListener('pause', () => {
    notifyListeners('pause');
  });
  
  audio.addEventListener('error', (e) => {
    console.error('[AudioManager] âŒ Erro no Ã¡udio:', e);
    notifyListeners('error', e);
  });
}

// Sistema de listeners para componentes React
export const addAudioListener = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

function notifyListeners(event, data = {}) {
  listeners.forEach(callback => {
    try {
      callback(event, data);
    } catch (error) {
      console.error('[AudioManager] Erro no listener:', error);
    }
  });
}

// API expandida para controles
export const audioControls = {
  play: (url) => {
    const { audioElement } = initGlobalAudio();
    
    if (url && audioElement.src !== url) {
      audioElement.src = url;
    }
    
    return audioElement.play();
  },
  
  pause: () => {
    const { audioElement } = initGlobalAudio();
    audioElement.pause();
  },
  
  setVolume: (volume) => {
    const { audioElement } = initGlobalAudio();
    audioElement.volume = Math.max(0, Math.min(1, volume));
  },
  
  seek: (time) => {
    const { audioElement } = initGlobalAudio();
    audioElement.currentTime = time;
  },
  
  // Estado atual
  getState: () => {
    const { audioElement } = initGlobalAudio();
    return {
      isPlaying: !audioElement.paused,
      currentTime: audioElement.currentTime || 0,
      duration: audioElement.duration || 0,
      volume: audioElement.volume,
      src: audioElement.src
    };
  }
};

// CRÃTICO: playSpot agora apenas expÃµe elementos, NÃƒO faz ducking
// O ducking Ã© responsabilidade do useAudio.js
export const playSpot = async (url, volume = 1) => {
  const { spotElement } = initGlobalAudio();
  
  console.log('[AudioManager] ðŸ“¢ Preparando spot:', url.substring(url.lastIndexOf('/') + 1));
  
  // Apenas configurar e tocar - NÃƒO mexer no volume da mÃºsica
  spotElement.src = url;
  spotElement.volume = volume;
  
  // use listener com {once:true} para nÃ£o acumular handlers
  spotElement.addEventListener('ended', () => {
    console.log('[AudioManager] âœ… Spot terminou');
    notifyListeners('spotEnded');
  }, { once: true });
  
  return spotElement.play();
};

// Debug helper
export const debugAudio = () => {
  const state = audioControls.getState();
  console.log('[AudioManager] ðŸ” Debug Estado:', {
    ...state,
    elementoGlobal: !!window.__globalAudioElement,
    spotGlobal: !!window.__globalSpotElement,
    volumeAtual: state.volume,
    inicializado: isInitialized
  });
  return state;
};

// âœ… FunÃ§Ã£o para resetar (Ãºtil para testes)
export const resetAudioManager = () => {
  console.warn('[AudioManager] âš ï¸ Resetando AudioManager...');
  
  if (globalAudioElement) {
    globalAudioElement.pause();
    globalAudioElement.src = '';
    globalAudioElement = null;
  }
  
  if (globalSpotElement) {
    globalSpotElement.pause();
    globalSpotElement.src = '';
    globalSpotElement = null;
  }
  
  listeners.clear();
  isInitialized = false;
  
  delete window.__globalAudioElement;
  delete window.__globalSpotElement;
  
  console.log('[AudioManager] âœ… Reset concluÃ­do');
};

// Exportar tudo como default tambÃ©m
export default {
  initGlobalAudio,
  getAudioElement,
  getSpotElement,
  addAudioListener,
  audioControls,
  playSpot,
  debugAudio,
  resetAudioManager,
  setBeforeMusicEndHook
};